import { useI18n } from 'locales'

import {
  InvoiceBillingGrid,
  InvoiceDetailColumn,
  InvoiceDetailLabel,
  InvoiceDetailBodyLine,
  InvoiceDetailDateText,
} from './styles'

const InvoiceMobileBillingGrid = ({
  invoice,
  billerBusinessName,
  createdAtFormatted,
  dueAtFormatted,
}) => {
  const { i18n } = useI18n()

  return (
    <InvoiceBillingGrid>
      {/* Row 1: Billed to | Invoice date */}
      <InvoiceDetailColumn>
        <InvoiceDetailLabel>
          {`${i18n.t('booking.invoice.billed_to')}:`}
        </InvoiceDetailLabel>
        {invoice?.contact?.full_name ? (
          <InvoiceDetailBodyLine>{invoice.contact.full_name}</InvoiceDetailBodyLine>
        ) : null}
        {invoice?.contact?.primary_email ? (
          <InvoiceDetailBodyLine>
            {invoice.contact.primary_email}
          </InvoiceDetailBodyLine>
        ) : null}
      </InvoiceDetailColumn>
      <InvoiceDetailColumn>
        <InvoiceDetailLabel>
          {`${i18n.t('booking.invoice.invoice_date')}:`}
        </InvoiceDetailLabel>
        <InvoiceDetailDateText>{createdAtFormatted}</InvoiceDetailDateText>
      </InvoiceDetailColumn>
      {/* Row 2: Billed from | Due date */}
      <InvoiceDetailColumn>
        <InvoiceDetailLabel>
          {`${i18n.t('booking.invoice.billed_from')}:`}
        </InvoiceDetailLabel>
        {invoice?.invoice_biller_info?.name ? (
          <InvoiceDetailBodyLine>
            {invoice.invoice_biller_info.name}
          </InvoiceDetailBodyLine>
        ) : null}
        {billerBusinessName ? (
          <InvoiceDetailBodyLine>{billerBusinessName}</InvoiceDetailBodyLine>
        ) : null}
        {invoice?.invoice_biller_info?.email ? (
          <InvoiceDetailBodyLine>
            {invoice.invoice_biller_info.email}
          </InvoiceDetailBodyLine>
        ) : null}
      </InvoiceDetailColumn>
      <InvoiceDetailColumn>
        <InvoiceDetailLabel>
          {`${i18n.t('booking.invoice.due_date')}:`}
        </InvoiceDetailLabel>
        <InvoiceDetailDateText>{dueAtFormatted}</InvoiceDetailDateText>
      </InvoiceDetailColumn>
    </InvoiceBillingGrid>
  )
}

export default InvoiceMobileBillingGrid
